import { TourSalesModel } from 'api-hooks/tour/tour-sale';
import { Option } from 'baseui/select';
import { PreferenceFormSchema } from 'common/form-schema';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

export const TourSaleItemGuestFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    tourPriceRefId: Yup.string().default(''),
    tourFlightRefId: Yup.string().default(''),
    bedType: Yup.string().default(''),
    groupNumber: Yup.string().default(''),
    price: Yup.number().default(0),
    note: Yup.string().default(''),
    guestId: Yup.string().default(''),

    //additional information
    tourPriceId: Yup.string().default(''),
    type: Yup.string().default(''),

    tourFlightId: Yup.string().default(''),
    flightName: Yup.string().default(''),

    customId: Yup.string(),
    guestName: Yup.string().default(''),
    guestPreferences: Yup.array(PreferenceFormSchema()).default([]),
  });

export const TourSaleItemAddOnsFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const TourSaleItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    customId: Yup.string(),
    tourSaleGuests: Yup.array(TourSaleItemGuestFormSchema()).default([]),
    tourSaleAddOns: Yup.array(TourSaleItemAddOnsFormSchema()).default([]),
  });

export const TourSaleFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    adminId: Yup.string().default(''),
    operatorId: Yup.string().default(''),
    salesmanId: Yup.string().default(''),
    customerId: Yup.string().default(''),
    customerBillingId: Yup.string().default(''),
    tourId: Yup.string().default(''),
    tourRefId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    tourSales: Yup.array(TourSaleItemFormSchema()).default([]),

    //additional information
    tourType: Yup.string().default(''),
    tempTransactionAt: Yup.date().default(new Date()),
    phone: Yup.string().default(''),
    address: Yup.string().default(''),
    number: Yup.string().default(''),
    customerStatus: Yup.string().default(''),
    hasDueReceivable: Yup.boolean().default(false),
    remainingTransactionQuota: Yup.number().nullable().default(null),
    isExceedingQuota: Yup.boolean().default(false),
  });

export type TourSaleFormType = Yup.InferType<
  ReturnType<typeof TourSaleFormSchema>
> & {
  tourSale?: TourSalesModel;
  customerBillingOptions: Option[];
  typeOptions: Option[];
  scheduleOptions: Option[];
  enumOptions: Option[];
};

export type TourSaleMethodType = ReturnType<typeof useForm<TourSaleFormType>>;

export type TourSaleItemFormType = Yup.InferType<
  ReturnType<typeof TourSaleItemFormSchema>
>;

export type TourSaleItemAddOnsFormType = Yup.InferType<
  ReturnType<typeof TourSaleItemAddOnsFormSchema>
>;

export type TourSaleItemGuestFormType = Yup.InferType<
  ReturnType<typeof TourSaleItemGuestFormSchema>
>;
